import {
    GET_PAYMENT_INTEGRATION_SETTINGS_STARTED,
    GET_PAYMENT_INTEGRATION_SETTINGS_SUCCESS,
    GET_PAYMENT_INTEGRATION_SETTINGS_FAILURE,
} from "../../constants/payment-integration-settings/paymentIntegrationSettings";

const initialState = {
    loading: false,
    defaultPaymentConnection: "",
    availableConnections: ["manual", "clover-local"],
    error: null,
    message: null,
};



export default function paymentIntegrationSettings(state = initialState, action) {
    switch (action.type) {
        case GET_PAYMENT_INTEGRATION_SETTINGS_STARTED:
            return { ...state, loading: true };
        case GET_PAYMENT_INTEGRATION_SETTINGS_SUCCESS:
            const { defaultPaymentConnection, availableConnections } = action.payload.data?.settings;
            localStorage.setItem('defaultPaymentConnection', defaultPaymentConnection);
            localStorage.setItem('availableConnections', JSON.stringify(availableConnections));
            return {
                ...state,
                loading: false,
                defaultPaymentConnection,
                availableConnections,
            };
        case GET_PAYMENT_INTEGRATION_SETTINGS_FAILURE:
            return { ...state, loading: false, error: action.payload.error };
        default:
            return state;
    }
}
